import NearbyLocality from '../locality/NearbyLocality';

import GroupedGallery from './GroupedGallery';
import './Gallery.css';

const GalleryPage = () => (
  <div>
    <h2 className="text-left my-4">Photo Gallery</h2>
    <GroupedGallery />
  </div>
);

export default GalleryPage;
